module.exports = __webpack_public_path__ + "assets/search-icon-mobile-bc109b.svg";